import React from "react";
import type { TransformedCartItem } from "../../../cart/types/cartApiTypes";
import CheckoutItemRow from "./CheckoutItemRow";

interface CheckoutItemsListProps {
  items: TransformedCartItem[];
  currencySymbol: string;
}

const CheckoutItemsList: React.FC<CheckoutItemsListProps> = ({
  items,
  currencySymbol,
}) => {
  return (
    <div className="order-summary-items">
      {items.map((item) => (
        <CheckoutItemRow
          key={item.key}
          item={item}
          currencySymbol={currencySymbol}
        />
      ))}
    </div>
  );
};

export default CheckoutItemsList;
